import {z as zod} from "zod";

export type Country = {
    countryCode: string;
    currencyCode: string;
    dialingCode: string;
    flag: string;
    id: CountryId;
    name: string;
    referenceExchangeRateAgainstUsd: number;
};

export enum CountryId {
    Albania = "171d1be4-9a17-4ea7-b55c-d0ed87237b1e",
    Algeria = "ded611a4-2e03-4e2c-8a9c-d1a17affd44f",
    AmericanSamoa = "dbd25d9c-66b7-4f29-a790-b8a81e7cd308",
    Andorra = "6bc24f78-4a89-4029-adcf-6aff6e295138",
    Angola = "3d374b33-3fdb-4df5-807a-f801905859c5",
    Anguilla = "2d86393b-3a57-43c7-945b-c8a388292d40",
    AntiguaAndBarbuda = "8b153fc2-6979-407b-8e36-c4c3db23182a",
    Argentina = "b3aa85f5-0be1-48b0-aba4-1122a6c6616f",
    Armenia = "ac50e60f-c583-4b53-bebf-d3d8fb867350",
    Aruba = "7dd4c4f5-465d-4e13-a353-6dbb66c5e2bf",
    Australia = "afc1286e-7c3d-4f73-a5fd-42e956f1181c",
    Austria = "d9919287-2316-43c8-a624-95743dfea0b0",
    Azerbaijan = "8d3681dd-7f26-4b5f-bc43-e99d66e8c3c5",
    Bahamas = "c41a0680-f829-45b4-9646-26627489bfa5",
    Bahrain = "3881834f-1e59-4783-bc6b-ff5d2c34a059",
    Bangladesh = "863d123f-5b37-45dd-876a-f50eccb5dc45",
    Barbados = "c2748c0c-6341-485b-8308-fa71512dc129",
    Belarus = "31172330-7961-4bc2-962f-bb8aac3b22d0",
    Belgium = "d42fd05e-6847-4c03-a42c-b30dc0f4320c",
    Belize = "1879815e-d2bc-4d28-b6f4-20f6837875a0",
    Benin = "4d0268ac-e8e6-49e6-af65-fae463084e8e",
    Bermuda = "eda6b971-10da-4e6d-9cb0-0bbb24fd10d2",
    Bhutan = "8973773a-a8b8-4392-9ab4-a648b6f81b8c",
    Bolivia = "5bd39ebd-8031-4f74-a8b6-d524565c36c0",
    Botswana = "edadb106-8379-46c5-a66a-a6d810994d8c",
    BouvetIsland = "479b6c41-59ee-47d0-aade-a29c419e4fa5",
    Brazil = "8b6374d4-ec99-4083-9ae8-8842bab31447",
    BritishIndianOceanTerritory = "373a5f0d-d8eb-4477-b481-4c11076baed9",
    Brunei = "eebb0136-fc62-41b8-b094-dfb77a1b2993",
    Bulgaria = "b0712949-22eb-4e2b-b797-faa560a1e055",
    BurkinaFaso = "e3800528-5174-482a-8d3a-f9cb48e277e4",
    Burundi = "6d9d3c2d-47d7-4940-9676-7923f0100a16",
    Cambodia = "2f989341-d380-4fca-a00a-86bf9dfbbccf",
    Cameroon = "432b3dd6-725c-4017-b391-7d296b81dee7",
    Canada = "681baf24-01e7-4f0a-b44c-595791c6c1a7",
    CapeVerde = "802f95b8-e588-4e20-b4ee-ffcddb4bd682",
    CaymanIslands = "5b25c86a-a21c-4e6d-ac1e-38933dc37c73",
    CentralAfricanRepublic = "29dbb67c-e30c-48f8-82cf-ea3d82efa7a5",
    Chad = "43a1b851-23be-45db-b74c-f2ce4aa6fb85",
    Chile = "cb686f8a-8843-4616-b92c-6d2312a9fd21",
    China = "39cd4200-384b-4af1-bc3e-f18faf20fc13",
    ChristmasIsland = "d91e87e4-3d3a-4faf-a62d-d5727d98369f",
    CocosIslands = "a4d07198-b086-4847-bc52-146694820a86",
    Colombia = "dfbbe3d6-dee6-4ed9-8024-8149beb2a17a",
    Comoros = "a3f1ab6f-ee0e-4df4-b491-86b801e470ba",
    Congo = "a019e269-e704-447f-b0a1-9dc5a3e3803f",
    CookIslands = "9a4dbaba-7d8b-436b-ab88-ab72d0904a2f",
    CostaRica = "a89da42f-b797-4232-ae0c-be912c0c5c9d",
    CoteDivoire = "6e2a9d7c-5182-4bed-902f-2c7f03d9fddd",
    Croatia = "47622cd8-10f6-447e-85ac-912b880dfe8b",
    Cuba = "bda43907-71a8-466d-8445-be8eb95c6357",
    Cyprus = "4cbb8ff8-d4e6-4681-a46e-84922fa3e1c3",
    CzechRepublic = "b12d435a-1482-4ccc-96cd-723db4bf19f7",
    Denmark = "e52aca71-67cb-4afe-bd3b-4639f1919e13",
    Djibouti = "f085ca69-085b-47e2-8ab7-fd5ae31d627f",
    Dominica = "506bc50a-5185-4944-a2b7-101a0a0d9cc2",
    DominicanRepublic = "c19f9a6b-cc71-4eda-9277-0bb6fcb67c09",
    Ecuador = "fb1c3bc6-7b85-4881-8dee-c52b9399f08c",
    Egypt = "8f26f2c3-ac7d-487a-95be-6c2f40e19ce1",
    ElSalvador = "fac9bc6a-8edb-44cc-8ea3-2cab60e3d1d2",
    EquatorialGuinea = "ce4e97d2-920d-40be-a9f0-a516e686c2c3",
    Eritrea = "f86cefaf-59c4-4301-b1e6-4c07b8ea82f9",
    Estonia = "11897157-3b72-4fdb-9db5-69e227576ead",
    Ethiopia = "e749c5b5-ca30-4be6-9862-93fad66529f9",
    FalklandIslands = "52da645f-ebe6-4f98-ba7d-76bdaeb67984",
    FaroeIslands = "09a66ef3-f9b7-4fa9-9e4b-4a57dc02f606",
    Fiji = "7fc9447a-94e7-48e3-8b1a-721781fe3b01",
    Finland = "a26629ab-9535-4a2b-ba80-1c5cff4925a2",
    France = "f013d80c-e160-4407-9796-fe368aa7b3df",
    FrenchGuiana = "3ab86dcc-bfa4-4758-b271-94ace325aa0a",
    FrenchPolynesia = "0a1aae12-210c-4e43-9440-3738b2b2dd84",
    FrenchSouthernTerritories = "c0e2286e-3f90-41bd-949d-d2d30d6f102f",
    Gabon = "3431d66d-dd65-45b0-a5ca-44013ed42647",
    Gambia = "a32b35f0-0f97-4584-94f7-6b52252a8208",
    Georgia = "46d93aa2-dffa-4e1f-b01e-ab248c282afc",
    Germany = "6fbff797-ae72-4e4e-aa2b-573a7d8513aa",
    Gibraltar = "342603c4-6bf3-41fa-917c-73a34f1341b7",
    Greece = "0ffe42d8-f53c-459b-9bd9-d6aaaac9d939",
    Greenland = "6b7422f5-c9cd-4e3e-88ca-5c336580ea3c",
    Grenada = "7fdbc028-588b-47c6-b11e-2546e01a371e",
    Guadeloupe = "7cf2aac0-d228-4fb1-89f9-583ee2cceaf6",
    Guam = "baf7f6db-ab34-40d5-9239-cc6f171ed8ff",
    Guatemala = "36c2716b-89f0-4bd0-ae35-44e2811c6656",
    Guinea = "3e14f22f-d317-435b-b554-2b2008910ee0",
    GuineaBissau = "4356427a-962f-4394-9b25-a098f6e8b1b3",
    Guyana = "83c4d048-fbec-42d5-b3c4-259e0863675a",
    Haiti = "c78e0ec5-ae89-4ea1-973b-5722898a8596",
    HeardIslandAndMcdonaldIslands = "4a820d37-881a-400f-ae3f-fc7c4210b984",
    Samoa = "7b4066a6-9d77-430d-b578-a314358e1919",
    Honduras = "c852a36d-4f98-47bb-9751-d17e740fd3df",
    HongKong = "f8b0a179-888a-4fd7-8fc5-5d61ffb2a553",
    Hungary = "89543a9f-3c8f-408e-813b-b325f5b6d696",
    Iceland = "96c36cfa-9590-4f9d-8a3e-4722189ca446",
    India = "6ee8bf88-b3a6-4db8-b4b5-be54b33dc7b1",
    Indonesia = "ecbaba0d-8844-495e-a243-417b3c32fed9",
    Iran = "1698abda-acf4-4c06-8996-4d87d0a0c996",
    Ireland = "a5e00e67-4708-481a-a60c-7c54ef7b549c",
    Israel = "27a3ca48-3a66-48a9-8ad1-e025039e64d3",
    Italy = "4ac291c4-4ac7-411e-9a89-4b641ee81157",
    Jamaica = "109f5844-3144-4fff-a1d4-0469537d5188",
    Japan = "62c1d47f-e540-4000-aba5-f606c3fdd3c0",
    Jordan = "174e5d5c-2b2f-4273-8de6-993d7dd80264",
    Kazakhstan = "bc20fabd-2b4f-4127-9893-57e082719bae",
    Kenya = "7ae5f18a-4def-44ce-863c-5246c42ab4e6",
    Kiribati = "8fe65762-1b41-47e2-80e2-27da2263f4e7",
    NorthKorea = "4b838a37-dff9-4d14-9521-277c82c0d3a6",
    SouthKorea = "0a0b691d-1dc2-40db-b5a5-45366ae70bdb",
    Kosovo = "16854d9d-f334-47b5-ba7b-cb4fe58bc4ea",
    Kuwait = "81a11434-5ea4-4711-8138-b9546434c1b2",
    Kyrgyzstan = "05d708f9-09b4-4bc5-8992-0883facc6beb",
    Laos = "40318fda-e174-4f02-8159-dc0a85e5aa99",
    Latvia = "98e1cb48-8436-47f5-a5ce-f1647b2e6c53",
    Lebanon = "01321d4c-022d-49b1-97da-3f8d8237179c",
    Lesotho = "6799c652-5028-44a4-abce-c042070d14d0",
    Liberia = "b1f14cd4-47ec-4066-80f0-ddaf1b8b94ca",
    Libya = "24d77f22-e47b-4845-abe8-502b3989ae93",
    Lithuania = "b5b75c04-9531-412f-a8a0-501781a3a976",
    Luxembourg = "0d620c32-6193-475d-be94-f49e0ae72880",
    Macao = "38740c37-febf-4606-a689-1dfd8c698db6",
    NorthMacedonia = "7f6924e6-7f1e-4eef-975d-9302dea68451",
    Malawi = "8a472304-75f6-4214-8040-5b545aec0439",
    Malaysia = "2a72561e-844d-4cb5-bf4a-368068ed06ba",
    Maldives = "cbd0670f-a687-4449-9a67-7496adee702e",
    Mali = "0c4814c7-7683-4630-9668-e47d2e46ed62",
    Malta = "f86c7ea8-e00c-4567-bc44-2e1134c4d012",
    MarshallIslands = "992062c4-50c4-4e1a-9939-9635a866ef57",
    Martinique = "79fddf42-40ad-4b1b-939d-3e477d50080d",
    Mauritania = "137b9e5e-87fa-4d01-a252-6287ec5b7aa8",
    Mauritius = "73172029-7f02-4356-ad98-0ad48d478172",
    Mayotte = "6f00d4ff-92b7-41ae-8192-606cf0aaa04c",
    Mexico = "dda4d0b0-012c-4879-bb93-c29c4abe7869",
    Micronesia = "d9793b02-fbcc-4fa7-97a9-c25f4a494576",
    Moldova = "a572e31d-f6ce-49a4-8243-8c0d969b2f28",
    Monaco = "e4bae28c-e3b7-4c0e-8fc5-3fcd81ccf543",
    Mongolia = "c1b79238-c0d8-41cf-9110-407b1c6cd45b",
    Montenegro = "29c1b4af-59ea-4379-8cf7-518336005d8c",
    Montserrat = "ac6dc961-9bcf-46db-824a-b5725e2ccb1e",
    Morocco = "c5b94a69-68e3-4834-9c5e-0ea9f905197e",
    Namibia = "7e1f87fe-e75f-452f-9db2-5469bdf1fc26",
    Nauru = "e698f090-5c98-4ffe-a777-79c3f0a44a1a",
    Nepal = "2f9519e4-3b07-41d7-9531-fcd890032dec",
    Netherlands = "e4dae07f-79b2-43a8-93a2-9f1368849838",
    NetherlandsAntilles = "5e97e9d7-9d99-4f76-8657-c9e9d8870756",
    NewCaledonia = "f9416330-3a91-4dfd-946f-abc1e645c9b3",
    NewZealand = "3dd2011d-30cd-406d-a55c-b29bfa4c3594",
    Nicaragua = "7b0c1c41-e422-4501-b6ea-170dbada1c49",
    Niger = "d7bff831-b5fb-45b0-958d-f48df7079551",
    Nigeria = "36a658fa-1547-4da0-8db1-37231bbd0a1e",
    Niue = "b193a524-e836-42ba-83f7-7befab3f259b",
    NorfolkIsland = "dea987b5-12d8-4365-bf8b-f96693fb32fc",
    NorthernMarianaIslands = "5731f820-d3f4-4cc3-8048-625ef8b0ece1",
    Norway = "5a8308a8-6265-4744-a3e5-b27084a4e17e",
    Oman = "eaabb46a-9fb4-49a5-9909-551b61c6cd30",
    Pakistan = "20c313fc-9d24-43fa-ae67-14cfbad647b1",
    Palau = "02a14382-f42e-4dd5-8549-c7f3e9d8c633",
    Panama = "4665836f-8544-4ab8-92cf-c54573cc65db",
    PapuaNewGuinea = "288f3a30-4330-402d-86d7-1af2340cee2d",
    Paraguay = "71dad3bc-56e1-40bf-ae3d-cdc3346686c5",
    Peru = "c981d94d-64fd-417b-b7f2-d7ad68638bf6",
    Philippines = "501a4fc4-b68d-4c16-9270-08d0467f9647",
    Pitcairn = "b2dc7721-3b95-4511-9e5e-5d0b77343349",
    Poland = "f4f1f916-e5fc-478b-a46c-9722ce564b14",
    Portugal = "058776ee-d730-4a55-b69a-54e3ef3fd711",
    PuertoRico = "7a5097ca-7575-4790-827d-cfba9c35ef2f",
    Qatar = "0871467a-0dba-41c0-b71b-932dff6d03d6",
    Romania = "91224851-6b45-47a2-af0b-64949cc7be6e",
    Russia = "0cdd61b3-5a95-4196-862c-0a660b9adf8c",
    Rwanda = "30e8e188-6d7c-4256-97f0-0f9b7ddcbc07",
    Reunion = "61f384bc-31e5-4764-b1a3-d5554a9580e3",
    SaintBarthelemy = "15b6eca4-a7e0-4d3b-9606-36d93a436e1e",
    SaintHelenaAscensionAndTristanDaCunha = "dca48874-8b2c-4093-bc54-bd0c8097dcc0",
    SaintKittsAndNevis = "e4329938-4f57-48a5-a226-90a7f070ed58",
    SaintLucia = "23aff971-c9d3-4692-86df-4bfcb412af69",
    SaintMartin = "d1707179-ff26-49db-8a0f-198330c17739",
    SaintPierreAndMiquelon = "291effa0-0b00-4821-9d6a-bf0f44f266c3",
    SaintVincentAndTheGrenadines = "c490a480-3592-44ae-9adb-4fd40714f8fd",
    Myanmar = "20c5e678-bfa7-4d66-ac0a-6392c10d5cf8",
    SanMarino = "4a77ff4f-94a2-474a-91d0-5e3219a6e7a5",
    SaoTomeAndPrincipe = "4dca9c3b-e3f0-4654-86c0-217619772ccd",
    Afghanistan = "633a20df-d6eb-4d09-903f-c935ba464146",
    Antarctica = "c632d290-e621-4458-b820-ad205e32bd09",
    BosniaAndHerzegovina = "3e0a2e33-7d2e-480d-b332-9377d740a90c",
    DominicanRepublicOfCongo = "a845077b-0c5c-4475-913c-bbec5c874fab",
    Ghana = "9b11bf47-78cb-4614-87ab-20e29c40d6f1",
    HolySee = "232f8a32-2831-4249-89b8-03f4f7db4c95",
    Iraq = "25b22001-06db-49a6-9f65-15a2d507593e",
    Liechtenstein = "92a7fa3a-6a2f-4b7e-b71e-b0475e92cf71",
    Mozambique = "0a1158f4-7dff-43b1-b029-152b772c191f",
    PalestinianTerritoryOccupied = "71c70b1d-e1a9-4ada-82a9-22595cd44008",
    SaudiArabia = "74eca88d-ec24-4deb-b7e8-4c8d0a3fe10b",
    Senegal = "a53c680c-20c7-4ff3-a9d3-2ffd3057f901",
    Serbia = "686a2bab-e624-4128-b5d6-90d1abefe105",
    Seychelles = "82529194-2697-43c5-9f77-3c26d46efda5",
    SierraLeone = "7ea62b12-b471-4ce6-8560-bb3b0003d56a",
    Singapore = "185b3196-2ace-4b99-b262-054bdd53a808",
    Slovakia = "726d54b4-2d49-4864-8396-932dbe5040bf",
    Slovenia = "6ff3c646-f940-4e48-afe7-cc7db1b6a8e4",
    SolomonIslands = "106c3015-eed8-4790-9974-f2519b690cd9",
    Somalia = "dd42ad1d-c8ee-4f10-967a-3eaae22a5fb8",
    SouthAfrica = "f4bd0ee3-ca1b-4d9f-a40d-04f99f214509",
    SouthSudan = "a91a27c7-707d-4b22-8b42-39ddb537af20",
    SouthGeorgiaAndTheSouthSandwichIslands = "ee455f6c-2162-4861-9b77-b1205b181e91",
    Spain = "e4d48f4b-65d8-487e-a7b1-edbb57d145ea",
    SriLanka = "3c3768b5-128b-42ce-9002-649d5b7d6b47",
    Sudan = "64715d14-adcd-495b-adda-e4ac1fe02c13",
    Suriname = "544e90d3-1d44-40c0-9109-3f5c665d39ac",
    SvalbardAndJanMayen = "4e9405e6-c254-4d23-b591-ad785db0387c",
    Eswatini = "20259cd0-c793-4212-a191-473c929f080e",
    Sweden = "d33f99e8-c165-4412-8549-03a84a1b4ed5",
    Switzerland = "fb5e677d-d415-4b4c-9e55-3c115ac06d2a",
    Syria = "1b9d9aa6-9d88-4132-b4b6-e2b6be9b6823",
    Taiwan = "81f42001-304f-4e97-b50a-c7ae3405c3a9",
    Tajikistan = "dee652e6-8fde-445e-9b1b-c96d3a135f8d",
    Tanzania = "05cff77e-3658-4281-ba20-f03a088aa5a6",
    Thailand = "2d4efbe0-63d5-47fa-a0ec-b2d79fe269ec",
    TimorLeste = "801772d9-136c-4e22-ad46-319ef1f33025",
    Togo = "c4b05399-cee6-4a6c-927d-e13eb3f4c396",
    Tokelau = "c9a7389e-1f1f-48a6-9d78-ec6ac3faefd7",
    Tonga = "b7a69288-cb10-4b58-808d-016697441044",
    TrinidadAndTobago = "98230ea8-4b17-49f8-a38b-e18654ea4ce9",
    Tunisia = "c0aee710-ec05-4b3c-9517-90924e637a38",
    Turkey = "36f6f2c8-141d-4f8c-b64d-5c699888df01",
    Turkmenistan = "5c0acb72-5da1-4783-9f11-03d2930351ad",
    TurksAndCaicosIslands = "f5c075a4-87ef-4126-8c31-4a4e9cdfcfdc",
    Tuvalu = "0316dd0e-cb5a-4f09-bf0f-5e2163f319a2",
    Uganda = "71ddb592-f89e-4f7f-a617-695dd1274f40",
    Ukraine = "3e432cdd-945a-4d6b-8be5-aadfa3a99570",
    UnitedArabEmirates = "9c779acf-c2b8-4b2c-818a-83b2bd317e0d",
    UnitedKingdom = "731410ac-1d08-4908-9660-9d3c32a4769b",
    UnitedStates = "a9bba5ef-730a-491c-b0ea-53cfab6a7098",
    Uruguay = "7b50f859-2c62-4cc3-bb4c-c15ce70ef3ac",
    Uzbekistan = "03a44873-7e11-48bc-a056-5db4952c40a2",
    Vanuatu = "c4b868d9-280b-4ba7-ba57-799aa07e8185",
    Venezuela = "468a97c2-5c75-4330-bb72-6e2a00357e65",
    Vietnam = "b98b3103-b805-42c7-8ba2-a77adce19f59",
    VirginIslandsBritish = "c8231338-4abb-4b4c-917b-fcd96389e51b",
    VirginIslandsUnitedStates = "4688993b-bd09-477a-9caa-df2918d3fba0",
    WallisAndFutuna = "7287223c-6015-4b56-827e-6014df81d3a7",
    Yemen = "d6ed8d0b-83f9-461a-ba3a-671b266c80fc",
    Zambia = "25910b83-e735-4caa-a1bd-5cb15ef91a65",
    Zimbabwe = "4b4280c7-d11b-4c41-8704-08be17729969",
    Madagascar = "0d05814d-47ba-4362-b096-494e9a3f183a",
}

export const allCountries = [
    {
        "countryCode": "AL",
        "currencyCode": "ALL",
        "dialingCode": "355",
        "flag": "🇦🇱",
        "id": CountryId.Albania,
        "name": "Albania",
        "referenceExchangeRateAgainstUsd": 99.158753
    },
    {
        "countryCode": "DZ",
        "currencyCode": "DZD",
        "dialingCode": "213",
        "flag": "🇩🇿",
        "id": CountryId.Algeria,
        "name": "Algeria",
        "referenceExchangeRateAgainstUsd": 137.117932
    },
    {
        "countryCode": "AS",
        "currencyCode": "USD",
        "dialingCode": "1684",
        "flag": "🇦🇸",
        "id": CountryId.AmericanSamoa,
        "name": "American Samoa",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "AD",
        "currencyCode": "EUR",
        "dialingCode": "376",
        "flag": "🇦🇩",
        "id": CountryId.Andorra,
        "name": "Andorra",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "AO",
        "currencyCode": "AOA",
        "dialingCode": "244",
        "flag": "🇦🇴",
        "id": CountryId.Angola,
        "name": "Angola",
        "referenceExchangeRateAgainstUsd": 836.537186
    },
    {
        "countryCode": "AI",
        "currencyCode": "XCD",
        "dialingCode": "1264",
        "flag": "🇦🇮",
        "id": CountryId.Anguilla,
        "name": "Anguilla",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "AG",
        "currencyCode": "XCD",
        "dialingCode": "1268",
        "flag": "🇦🇬",
        "id": CountryId.AntiguaAndBarbuda,
        "name": "Antigua and Barbuda",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "AR",
        "currencyCode": "ARS",
        "dialingCode": "54",
        "flag": "🇦🇷",
        "id": CountryId.Argentina,
        "name": "Argentina",
        "referenceExchangeRateAgainstUsd": 350.03
    },
    {
        "countryCode": "AM",
        "currencyCode": "AMD",
        "dialingCode": "374",
        "flag": "🇦🇲",
        "id": CountryId.Armenia,
        "name": "Armenia",
        "referenceExchangeRateAgainstUsd": 402.205304
    },
    {
        "countryCode": "AW",
        "currencyCode": "AWG",
        "dialingCode": "297",
        "flag": "🇦🇼",
        "id": CountryId.Aruba,
        "name": "Aruba",
        "referenceExchangeRateAgainstUsd": 1.79
    },
    {
        "countryCode": "AU",
        "currencyCode": "AUD",
        "dialingCode": "61",
        "flag": "🇦🇺",
        "id": CountryId.Australia,
        "name": "Australia",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "AT",
        "currencyCode": "EUR",
        "dialingCode": "43",
        "flag": "🇦🇹",
        "id": CountryId.Austria,
        "name": "Austria",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "AZ",
        "currencyCode": "AZN",
        "dialingCode": "994",
        "flag": "🇦🇿",
        "id": CountryId.Azerbaijan,
        "name": "Azerbaijan",
        "referenceExchangeRateAgainstUsd": 1.70044
    },
    {
        "countryCode": "BS",
        "currencyCode": "BSD",
        "dialingCode": "1242",
        "flag": "🇧🇸",
        "id": CountryId.Bahamas,
        "name": "Bahamas",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "BH",
        "currencyCode": "BHD",
        "dialingCode": "973",
        "flag": "🇧🇭",
        "id": CountryId.Bahrain,
        "name": "Bahrain",
        "referenceExchangeRateAgainstUsd": 0.376
    },
    {
        "countryCode": "BD",
        "currencyCode": "BDT",
        "dialingCode": "880",
        "flag": "🇧🇩",
        "id": CountryId.Bangladesh,
        "name": "Bangladesh",
        "referenceExchangeRateAgainstUsd": 110.21631
    },
    {
        "countryCode": "BB",
        "currencyCode": "BBD",
        "dialingCode": "1246",
        "flag": "🇧🇧",
        "id": CountryId.Barbados,
        "name": "Barbados",
        "referenceExchangeRateAgainstUsd": 2
    },
    {
        "countryCode": "BY",
        "currencyCode": "BYR",
        "dialingCode": "375",
        "flag": "🇧🇾",
        "id": CountryId.Belarus,
        "name": "Belarus",
        "referenceExchangeRateAgainstUsd": 3.27
    },
    {
        "countryCode": "BE",
        "currencyCode": "EUR",
        "dialingCode": "32",
        "flag": "🇧🇪",
        "id": CountryId.Belgium,
        "name": "Belgium",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "BZ",
        "currencyCode": "BZD",
        "dialingCode": "501",
        "flag": "🇧🇿",
        "id": CountryId.Belize,
        "name": "Belize",
        "referenceExchangeRateAgainstUsd": 2
    },
    {
        "countryCode": "BJ",
        "currencyCode": "XOF",
        "dialingCode": "229",
        "flag": "🇧🇯",
        "id": CountryId.Benin,
        "name": "Benin",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "BM",
        "currencyCode": "BMD",
        "dialingCode": "1441",
        "flag": "🇧🇲",
        "id": CountryId.Bermuda,
        "name": "Bermuda",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "BT",
        "currencyCode": "BTN",
        "dialingCode": "975",
        "flag": "🇧🇹",
        "id": CountryId.Bhutan,
        "name": "Bhutan",
        "referenceExchangeRateAgainstUsd": 83.057946
    },
    {
        "countryCode": "BO",
        "currencyCode": "BOB",
        "dialingCode": "591",
        "flag": "🇧🇴",
        "id": CountryId.Bolivia,
        "name": "Bolivia",
        "referenceExchangeRateAgainstUsd": 6.910072
    },
    {
        "countryCode": "BW",
        "currencyCode": "BWP",
        "dialingCode": "267",
        "flag": "🇧🇼",
        "id": CountryId.Botswana,
        "name": "Botswana",
        "referenceExchangeRateAgainstUsd": 13.798593
    },
    {
        "countryCode": "BV",
        "currencyCode": "NOK",
        "dialingCode": "47",
        "flag": "🇧🇻",
        "id": CountryId.BouvetIsland,
        "name": "Bouvet Island",
        "referenceExchangeRateAgainstUsd": 11.156498
    },
    {
        "countryCode": "BR",
        "currencyCode": "BRL",
        "dialingCode": "55",
        "flag": "🇧🇷",
        "id": CountryId.Brazil,
        "name": "Brazil",
        "referenceExchangeRateAgainstUsd": 5.015355
    },
    {
        "countryCode": "IO",
        "currencyCode": "USD",
        "dialingCode": "246",
        "flag": "🇮🇴",
        "id": CountryId.BritishIndianOceanTerritory,
        "name": "British Indian Ocean Territory",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "BN",
        "currencyCode": "BND",
        "dialingCode": "673",
        "flag": "🇧🇳",
        "id": CountryId.Brunei,
        "name": "Brunei",
        "referenceExchangeRateAgainstUsd": 1.36808
    },
    {
        "countryCode": "BG",
        "currencyCode": "BGN",
        "dialingCode": "359",
        "flag": "🇧🇬",
        "id": CountryId.Bulgaria,
        "name": "Bulgaria",
        "referenceExchangeRateAgainstUsd": 1.844392
    },
    {
        "countryCode": "BF",
        "currencyCode": "XOF",
        "dialingCode": "226",
        "flag": "🇧🇫",
        "id": CountryId.BurkinaFaso,
        "name": "Burkina Faso",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "BI",
        "currencyCode": "BIF",
        "dialingCode": "257",
        "flag": "🇧🇮",
        "id": CountryId.Burundi,
        "name": "Burundi",
        "referenceExchangeRateAgainstUsd": 2827.95007
    },
    {
        "countryCode": "KH",
        "currencyCode": "KHR",
        "dialingCode": "855",
        "flag": "🇰🇭",
        "id": CountryId.Cambodia,
        "name": "Cambodia",
        "referenceExchangeRateAgainstUsd": 4116.745724
    },
    {
        "countryCode": "CM",
        "currencyCode": "XAF",
        "dialingCode": "237",
        "flag": "🇨🇲",
        "id": CountryId.Cameroon,
        "name": "Cameroon",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "CA",
        "currencyCode": "CAD",
        "dialingCode": "1",
        "flag": "🇨🇦",
        "id": CountryId.Canada,
        "name": "Canada",
        "referenceExchangeRateAgainstUsd": 1.373031
    },
    {
        "countryCode": "CV",
        "currencyCode": "CVE",
        "dialingCode": "238",
        "flag": "🇨🇻",
        "id": CountryId.CapeVerde,
        "name": "Cape Verde",
        "referenceExchangeRateAgainstUsd": 104.01534
    },
    {
        "countryCode": "KY",
        "currencyCode": "KYD",
        "dialingCode": "345",
        "flag": "🇰🇾",
        "id": CountryId.CaymanIslands,
        "name": "Cayman Islands",
        "referenceExchangeRateAgainstUsd": 0.833333
    },
    {
        "countryCode": "CF",
        "currencyCode": "XAF",
        "dialingCode": "236",
        "flag": "🇨🇫",
        "id": CountryId.CentralAfricanRepublic,
        "name": "Central African Remasters",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "TD",
        "currencyCode": "XAF",
        "dialingCode": "235",
        "flag": "🇹🇩",
        "id": CountryId.Chad,
        "name": "Chad",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "CL",
        "currencyCode": "CLP",
        "dialingCode": "56",
        "flag": "🇨🇱",
        "id": CountryId.Chile,
        "name": "Chile",
        "referenceExchangeRateAgainstUsd": 932.673634
    },
    {
        "countryCode": "CN",
        "currencyCode": "CNY",
        "dialingCode": "86",
        "flag": "🇨🇳",
        "id": CountryId.China,
        "name": "China",
        "referenceExchangeRateAgainstUsd": 7.312497
    },
    {
        "countryCode": "CX",
        "currencyCode": "AUD",
        "dialingCode": "61",
        "flag": "🇨🇽",
        "id": CountryId.ChristmasIsland,
        "name": "Christmas Island",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "CC",
        "currencyCode": "AUD",
        "dialingCode": "61",
        "flag": "🇨🇨",
        "id": CountryId.CocosIslands,
        "name": "Cocos (Keeling) Islands",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "CO",
        "currencyCode": "COP",
        "dialingCode": "57",
        "flag": "🇨🇴",
        "id": CountryId.Colombia,
        "name": "Colombia",
        "referenceExchangeRateAgainstUsd": 4232.047134
    },
    {
        "countryCode": "KM",
        "currencyCode": "KMF",
        "dialingCode": "269",
        "flag": "🇰🇲",
        "id": CountryId.Comoros,
        "name": "Comoros",
        "referenceExchangeRateAgainstUsd": 464.083733
    },
    {
        "countryCode": "CG",
        "currencyCode": "XAF",
        "dialingCode": "242",
        "flag": "🇨🇬",
        "id": CountryId.Congo,
        "name": "Congo",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "CK",
        "currencyCode": "NZD",
        "dialingCode": "682",
        "flag": "🇨🇰",
        "id": CountryId.CookIslands,
        "name": "Cook Islands",
        "referenceExchangeRateAgainstUsd": 1.711312
    },
    {
        "countryCode": "CR",
        "currencyCode": "CRC",
        "dialingCode": "506",
        "flag": "🇨🇷",
        "id": CountryId.CostaRica,
        "name": "Costa Rica",
        "referenceExchangeRateAgainstUsd": 531.646838
    },
    {
        "countryCode": "CI",
        "currencyCode": "XOF",
        "dialingCode": "225",
        "flag": "🇨🇮",
        "id": CountryId.CoteDivoire,
        "name": "Cote d'Ivoire",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "HR",
        "currencyCode": "EUR",
        "dialingCode": "385",
        "flag": "🇭🇷",
        "id": CountryId.Croatia,
        "name": "Croatia",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "CU",
        "currencyCode": "CUP",
        "dialingCode": "53",
        "flag": "🇨🇺",
        "id": CountryId.Cuba,
        "name": "Cuba",
        "referenceExchangeRateAgainstUsd": 24
    },
    {
        "countryCode": "CY",
        "currencyCode": "EUR",
        "dialingCode": "357",
        "flag": "🇨🇾",
        "id": CountryId.Cyprus,
        "name": "Cyprus",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "CZ",
        "currencyCode": "CZK",
        "dialingCode": "420",
        "flag": "🇨🇿",
        "id": CountryId.CzechRepublic,
        "name": "Czech Remasters",
        "referenceExchangeRateAgainstUsd": 23.219714
    },
    {
        "countryCode": "DK",
        "currencyCode": "DKK",
        "dialingCode": "45",
        "flag": "🇩🇰",
        "id": CountryId.Denmark,
        "name": "Denmark",
        "referenceExchangeRateAgainstUsd": 7.040936
    },
    {
        "countryCode": "DJ",
        "currencyCode": "DJF",
        "dialingCode": "253",
        "flag": "🇩🇯",
        "id": CountryId.Djibouti,
        "name": "Djibouti",
        "referenceExchangeRateAgainstUsd": 177.721
    },
    {
        "countryCode": "DM",
        "currencyCode": "XCD",
        "dialingCode": "1767",
        "flag": "🇩🇲",
        "id": CountryId.Dominica,
        "name": "Dominica",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "DO",
        "currencyCode": "DOP",
        "dialingCode": "1849",
        "flag": "🇩🇴",
        "id": CountryId.DominicanRepublic,
        "name": "Dominican Remasters",
        "referenceExchangeRateAgainstUsd": 56.664123
    },
    {
        "countryCode": "EC",
        "currencyCode": "USD",
        "dialingCode": "593",
        "flag": "🇪🇨",
        "id": CountryId.Ecuador,
        "name": "Ecuador",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "EG",
        "currencyCode": "EGP",
        "dialingCode": "20",
        "flag": "🇪🇬",
        "id": CountryId.Egypt,
        "name": "Egypt",
        "referenceExchangeRateAgainstUsd": 30.915165
    },
    {
        "countryCode": "SV",
        "currencyCode": "USD",
        "dialingCode": "503",
        "flag": "🇸🇻",
        "id": CountryId.ElSalvador,
        "name": "El Salvador",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "GQ",
        "currencyCode": "XAF",
        "dialingCode": "240",
        "flag": "🇬🇶",
        "id": CountryId.EquatorialGuinea,
        "name": "Equatorial Guinea",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "ER",
        "currencyCode": "ERN",
        "dialingCode": "291",
        "flag": "🇪🇷",
        "id": CountryId.Eritrea,
        "name": "Eritrea",
        "referenceExchangeRateAgainstUsd": 15
    },
    {
        "countryCode": "EE",
        "currencyCode": "EUR",
        "dialingCode": "372",
        "flag": "🇪🇪",
        "id": CountryId.Estonia,
        "name": "Estonia",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "ET",
        "currencyCode": "ETB",
        "dialingCode": "251",
        "flag": "🇪🇹",
        "id": CountryId.Ethiopia,
        "name": "Ethiopia",
        "referenceExchangeRateAgainstUsd": 55.859642
    },
    {
        "countryCode": "FK",
        "currencyCode": "FKP",
        "dialingCode": "500",
        "flag": "🇫🇰",
        "id": CountryId.FalklandIslands,
        "name": "Falkland Islands (Malvinas)",
        "referenceExchangeRateAgainstUsd": 0.821186
    },
    {
        "countryCode": "FO",
        "currencyCode": "DKK",
        "dialingCode": "298",
        "flag": "🇫🇴",
        "id": CountryId.FaroeIslands,
        "name": "Faroe Islands",
        "referenceExchangeRateAgainstUsd": 7.040936
    },
    {
        "countryCode": "FJ",
        "currencyCode": "FJD",
        "dialingCode": "679",
        "flag": "🇫🇯",
        "id": CountryId.Fiji,
        "name": "Fiji",
        "referenceExchangeRateAgainstUsd": 2.275146
    },
    {
        "countryCode": "FI",
        "currencyCode": "EUR",
        "dialingCode": "358",
        "flag": "🇫🇮",
        "id": CountryId.Finland,
        "name": "Finland",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "FR",
        "currencyCode": "EUR",
        "dialingCode": "33",
        "flag": "🇫🇷",
        "id": CountryId.France,
        "name": "France",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "GF",
        "currencyCode": "EUR",
        "dialingCode": "594",
        "flag": "🇬🇫",
        "id": CountryId.FrenchGuiana,
        "name": "French Guiana",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "PF",
        "currencyCode": "XPF",
        "dialingCode": "689",
        "flag": "🇵🇫",
        "id": CountryId.FrenchPolynesia,
        "name": "French Polynesia",
        "referenceExchangeRateAgainstUsd": 112.568436
    },
    {
        "countryCode": "TF",
        "currencyCode": "EUR",
        "dialingCode": "262",
        "flag": "🇹🇫",
        "id": CountryId.FrenchSouthernTerritories,
        "name": "French Southern Territories",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "GA",
        "currencyCode": "XAF",
        "dialingCode": "241",
        "flag": "🇬🇦",
        "id": CountryId.Gabon,
        "name": "Gabon",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "GM",
        "currencyCode": "GMD",
        "dialingCode": "220",
        "flag": "🇬🇲",
        "id": CountryId.Gambia,
        "name": "Gambia",
        "referenceExchangeRateAgainstUsd": 64.850694
    },
    {
        "countryCode": "GE",
        "currencyCode": "GEL",
        "dialingCode": "995",
        "flag": "🇬🇪",
        "id": CountryId.Georgia,
        "name": "Georgia",
        "referenceExchangeRateAgainstUsd": 2.696829
    },
    {
        "countryCode": "DE",
        "currencyCode": "EUR",
        "dialingCode": "49",
        "flag": "🇩🇪",
        "id": CountryId.Germany,
        "name": "Germany",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "GI",
        "currencyCode": "GIP",
        "dialingCode": "350",
        "flag": "🇬🇮",
        "id": CountryId.Gibraltar,
        "name": "Gibraltar",
        "referenceExchangeRateAgainstUsd": 0.821186
    },
    {
        "countryCode": "GR",
        "currencyCode": "EUR",
        "dialingCode": "30",
        "flag": "🇬🇷",
        "id": CountryId.Greece,
        "name": "Greece",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "GL",
        "currencyCode": "DKK",
        "dialingCode": "299",
        "flag": "🇬🇱",
        "id": CountryId.Greenland,
        "name": "Greenland",
        "referenceExchangeRateAgainstUsd": 7.040936
    },
    {
        "countryCode": "GD",
        "currencyCode": "XCD",
        "dialingCode": "1473",
        "flag": "🇬🇩",
        "id": CountryId.Grenada,
        "name": "Grenada",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "GP",
        "currencyCode": "EUR",
        "dialingCode": "590",
        "flag": "🇬🇵",
        "id": CountryId.Guadeloupe,
        "name": "Guadeloupe",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "GU",
        "currencyCode": "USD",
        "dialingCode": "1671",
        "flag": "🇬🇺",
        "id": CountryId.Guam,
        "name": "Guam",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "GT",
        "currencyCode": "GTQ",
        "dialingCode": "502",
        "flag": "🇬🇹",
        "id": CountryId.Guatemala,
        "name": "Guatemala",
        "referenceExchangeRateAgainstUsd": 7.832815
    },
    {
        "countryCode": "GN",
        "currencyCode": "GNF",
        "dialingCode": "224",
        "flag": "🇬🇳",
        "id": CountryId.Guinea,
        "name": "Guinea",
        "referenceExchangeRateAgainstUsd": 8585.890467
    },
    {
        "countryCode": "GW",
        "currencyCode": "XOF",
        "dialingCode": "245",
        "flag": "🇬🇼",
        "id": CountryId.GuineaBissau,
        "name": "Guinea-Bissau",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "GY",
        "currencyCode": "GYD",
        "dialingCode": "592",
        "flag": "🇬🇾",
        "id": CountryId.Guyana,
        "name": "Guyana",
        "referenceExchangeRateAgainstUsd": 209.181369
    },
    {
        "countryCode": "HT",
        "currencyCode": "HTG",
        "dialingCode": "509",
        "flag": "🇭🇹",
        "id": CountryId.Haiti,
        "name": "Haiti",
        "referenceExchangeRateAgainstUsd": 133.488806
    },
    {
        "countryCode": "HM",
        "currencyCode": "AUD",
        "dialingCode": "672",
        "flag": "🇭🇲",
        "id": CountryId.HeardIslandAndMcdonaldIslands,
        "name": "Heard Island and Mcdonald Islands",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "WS",
        "currencyCode": "WST",
        "dialingCode": "685",
        "flag": "🇼🇸",
        "id": CountryId.Samoa,
        "name": "Samoa",
        "referenceExchangeRateAgainstUsd": 2.793099
    },
    {
        "countryCode": "HN",
        "currencyCode": "HNL",
        "dialingCode": "504",
        "flag": "🇭🇳",
        "id": CountryId.Honduras,
        "name": "Honduras",
        "referenceExchangeRateAgainstUsd": 24.700882
    },
    {
        "countryCode": "HK",
        "currencyCode": "HKD",
        "dialingCode": "852",
        "flag": "🇭🇰",
        "id": CountryId.HongKong,
        "name": "Hong Kong",
        "referenceExchangeRateAgainstUsd": 7.823278
    },
    {
        "countryCode": "HU",
        "currencyCode": "HUF",
        "dialingCode": "36",
        "flag": "🇭🇺",
        "id": CountryId.Hungary,
        "name": "Hungary",
        "referenceExchangeRateAgainstUsd": 360.918128
    },
    {
        "countryCode": "IS",
        "currencyCode": "ISK",
        "dialingCode": "354",
        "flag": "🇮🇸",
        "id": CountryId.Iceland,
        "name": "Iceland",
        "referenceExchangeRateAgainstUsd": 138.456636
    },
    {
        "countryCode": "IN",
        "currencyCode": "INR",
        "dialingCode": "91",
        "flag": "🇮🇳",
        "id": CountryId.India,
        "name": "India",
        "referenceExchangeRateAgainstUsd": 83.057974
    },
    {
        "countryCode": "ID",
        "currencyCode": "IDR",
        "dialingCode": "62",
        "flag": "🇮🇩",
        "id": CountryId.Indonesia,
        "name": "Indonesia",
        "referenceExchangeRateAgainstUsd": 15846.64763
    },
    {
        "countryCode": "IR",
        "currencyCode": "IRR",
        "dialingCode": "98",
        "flag": "🇮🇷",
        "id": CountryId.Iran,
        "name": "Iran",
        "referenceExchangeRateAgainstUsd": 41956.18735
    },
    {
        "countryCode": "IE",
        "currencyCode": "EUR",
        "dialingCode": "353",
        "flag": "🇮🇪",
        "id": CountryId.Ireland,
        "name": "Ireland",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "IL",
        "currencyCode": "ILS",
        "dialingCode": "972",
        "flag": "🇮🇱",
        "id": CountryId.Israel,
        "name": "Israel",
        "referenceExchangeRateAgainstUsd": 4.057882
    },
    {
        "countryCode": "IT",
        "currencyCode": "EUR",
        "dialingCode": "39",
        "flag": "🇮🇹",
        "id": CountryId.Italy,
        "name": "Italy",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "JM",
        "currencyCode": "JMD",
        "dialingCode": "1876",
        "flag": "🇯🇲",
        "id": CountryId.Jamaica,
        "name": "Jamaica",
        "referenceExchangeRateAgainstUsd": 154.806706
    },
    {
        "countryCode": "JP",
        "currencyCode": "JPY",
        "dialingCode": "81",
        "flag": "🇯🇵",
        "id": CountryId.Japan,
        "name": "Japan",
        "referenceExchangeRateAgainstUsd": 149.838918
    },
    {
        "countryCode": "JO",
        "currencyCode": "JOD",
        "dialingCode": "962",
        "flag": "🇯🇴",
        "id": CountryId.Jordan,
        "name": "Jordan",
        "referenceExchangeRateAgainstUsd": 0.709
    },
    {
        "countryCode": "KZ",
        "currencyCode": "KZT",
        "dialingCode": "7",
        "flag": "🇰🇿",
        "id": CountryId.Kazakhstan,
        "name": "Kazakhstan",
        "referenceExchangeRateAgainstUsd": 476.65433
    },
    {
        "countryCode": "KE",
        "currencyCode": "KES",
        "dialingCode": "254",
        "flag": "🇰🇪",
        "id": CountryId.Kenya,
        "name": "Kenya",
        "referenceExchangeRateAgainstUsd": 150.130138
    },
    {
        "countryCode": "KI",
        "currencyCode": "AUD",
        "dialingCode": "686",
        "flag": "🇰🇮",
        "id": CountryId.Kiribati,
        "name": "Kiribati",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "KP",
        "currencyCode": "KPW",
        "dialingCode": "850",
        "flag": "🇰🇵",
        "id": CountryId.NorthKorea,
        "name": "North Korea",
        "referenceExchangeRateAgainstUsd": 900
    },
    {
        "countryCode": "KR",
        "currencyCode": "KRW",
        "dialingCode": "82",
        "flag": "🇰🇷",
        "id": CountryId.SouthKorea,
        "name": "South Korea",
        "referenceExchangeRateAgainstUsd": 1344.237707
    },
    {
        "countryCode": "XK",
        "currencyCode": "EUR",
        "dialingCode": "383",
        "flag": "🇽🇰",
        "id": CountryId.Kosovo,
        "name": "Kosovo",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "KW",
        "currencyCode": "KWD",
        "dialingCode": "965",
        "flag": "🇰🇼",
        "id": CountryId.Kuwait,
        "name": "Kuwait",
        "referenceExchangeRateAgainstUsd": 0.309093
    },
    {
        "countryCode": "KG",
        "currencyCode": "KGS",
        "dialingCode": "996",
        "flag": "🇰🇬",
        "id": CountryId.Kyrgyzstan,
        "name": "Kyrgyzstan",
        "referenceExchangeRateAgainstUsd": 89.270867
    },
    {
        "countryCode": "LA",
        "currencyCode": "LAK",
        "dialingCode": "856",
        "flag": "🇱🇦",
        "id": CountryId.Laos,
        "name": "Laos",
        "referenceExchangeRateAgainstUsd": 20654.39255
    },
    {
        "countryCode": "LV",
        "currencyCode": "EUR",
        "dialingCode": "371",
        "flag": "🇱🇻",
        "id": CountryId.Latvia,
        "name": "Latvia",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "LB",
        "currencyCode": "LBP",
        "dialingCode": "961",
        "flag": "🇱🇧",
        "id": CountryId.Lebanon,
        "name": "Lebanon",
        "referenceExchangeRateAgainstUsd": 15000
    },
    {
        "countryCode": "LS",
        "currencyCode": "LSL",
        "dialingCode": "266",
        "flag": "🇱🇸",
        "id": CountryId.Lesotho,
        "name": "Lesotho",
        "referenceExchangeRateAgainstUsd": 19.039012
    },
    {
        "countryCode": "LR",
        "currencyCode": "LRD",
        "dialingCode": "231",
        "flag": "🇱🇷",
        "id": CountryId.Liberia,
        "name": "Liberia",
        "referenceExchangeRateAgainstUsd": 190.076206
    },
    {
        "countryCode": "LY",
        "currencyCode": "LYD",
        "dialingCode": "218",
        "flag": "🇱🇾",
        "id": CountryId.Libya,
        "name": "Libya",
        "referenceExchangeRateAgainstUsd": 4.897948
    },
    {
        "countryCode": "LT",
        "currencyCode": "EUR",
        "dialingCode": "370",
        "flag": "🇱🇹",
        "id": CountryId.Lithuania,
        "name": "Lithuania",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "LU",
        "currencyCode": "EUR",
        "dialingCode": "352",
        "flag": "🇱🇺",
        "id": CountryId.Luxembourg,
        "name": "Luxembourg",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MO",
        "currencyCode": "MOP",
        "dialingCode": "853",
        "flag": "🇲🇴",
        "id": CountryId.Macao,
        "name": "Macao",
        "referenceExchangeRateAgainstUsd": 8.057976
    },
    {
        "countryCode": "MK",
        "currencyCode": "MKD",
        "dialingCode": "389",
        "flag": "🇲🇰",
        "id": CountryId.NorthMacedonia,
        "name": "North Macedonia",
        "referenceExchangeRateAgainstUsd": 58.090086
    },
    {
        "countryCode": "MW",
        "currencyCode": "MWK",
        "dialingCode": "265",
        "flag": "🇲🇼",
        "id": CountryId.Malawi,
        "name": "Malawi",
        "referenceExchangeRateAgainstUsd": 1160.943874
    },
    {
        "countryCode": "MY",
        "currencyCode": "MYR",
        "dialingCode": "60",
        "flag": "🇲🇾",
        "id": CountryId.Malaysia,
        "name": "Malaysia",
        "referenceExchangeRateAgainstUsd": 4.784464
    },
    {
        "countryCode": "MV",
        "currencyCode": "MVR",
        "dialingCode": "960",
        "flag": "🇲🇻",
        "id": CountryId.Maldives,
        "name": "Maldives",
        "referenceExchangeRateAgainstUsd": 15.451169
    },
    {
        "countryCode": "ML",
        "currencyCode": "XOF",
        "dialingCode": "223",
        "flag": "🇲🇱",
        "id": CountryId.Mali,
        "name": "Mali",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "MT",
        "currencyCode": "EUR",
        "dialingCode": "356",
        "flag": "🇲🇹",
        "id": CountryId.Malta,
        "name": "Malta",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MH",
        "currencyCode": "USD",
        "dialingCode": "692",
        "flag": "🇲🇭",
        "id": CountryId.MarshallIslands,
        "name": "Marshall Islands",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "MQ",
        "currencyCode": "EUR",
        "dialingCode": "596",
        "flag": "🇲🇶",
        "id": CountryId.Martinique,
        "name": "Martinique",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MR",
        "currencyCode": "MRO",
        "dialingCode": "222",
        "flag": "🇲🇷",
        "id": CountryId.Mauritania,
        "name": "Mauritania",
        "referenceExchangeRateAgainstUsd": 39.95
    },
    {
        "countryCode": "MU",
        "currencyCode": "MUR",
        "dialingCode": "230",
        "flag": "🇲🇺",
        "id": CountryId.Mauritius,
        "name": "Mauritius",
        "referenceExchangeRateAgainstUsd": 44.571064
    },
    {
        "countryCode": "YT",
        "currencyCode": "EUR",
        "dialingCode": "262",
        "flag": "🇾🇹",
        "id": CountryId.Mayotte,
        "name": "Mayotte",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MX",
        "currencyCode": "MXN",
        "dialingCode": "52",
        "flag": "🇲🇽",
        "id": CountryId.Mexico,
        "name": "Mexico",
        "referenceExchangeRateAgainstUsd": 18.249386
    },
    {
        "countryCode": "FM",
        "currencyCode": "USD",
        "dialingCode": "691",
        "flag": "🇫🇲",
        "id": CountryId.Micronesia,
        "name": "Micronesia",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "MD",
        "currencyCode": "MDL",
        "dialingCode": "373",
        "flag": "🇲🇩",
        "id": CountryId.Moldova,
        "name": "Moldova",
        "referenceExchangeRateAgainstUsd": 18.174867
    },
    {
        "countryCode": "MC",
        "currencyCode": "EUR",
        "dialingCode": "377",
        "flag": "🇲🇨",
        "id": CountryId.Monaco,
        "name": "Monaco",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MN",
        "currencyCode": "MNT",
        "dialingCode": "976",
        "flag": "🇲🇳",
        "id": CountryId.Mongolia,
        "name": "Mongolia",
        "referenceExchangeRateAgainstUsd": 3449.71644
    },
    {
        "countryCode": "ME",
        "currencyCode": "EUR",
        "dialingCode": "382",
        "flag": "🇲🇪",
        "id": CountryId.Montenegro,
        "name": "Montenegro",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "MS",
        "currencyCode": "XCD",
        "dialingCode": "1664",
        "flag": "🇲🇸",
        "id": CountryId.Montserrat,
        "name": "Montserrat",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "MA",
        "currencyCode": "MAD",
        "dialingCode": "212",
        "flag": "🇲🇦",
        "id": CountryId.Morocco,
        "name": "Morocco",
        "referenceExchangeRateAgainstUsd": 10.296711
    },
    {
        "countryCode": "NA",
        "currencyCode": "NAD",
        "dialingCode": "264",
        "flag": "🇳🇦",
        "id": CountryId.Namibia,
        "name": "Namibia",
        "referenceExchangeRateAgainstUsd": 19.039012
    },
    {
        "countryCode": "NR",
        "currencyCode": "AUD",
        "dialingCode": "674",
        "flag": "🇳🇷",
        "id": CountryId.Nauru,
        "name": "Nauru",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "NP",
        "currencyCode": "NPR",
        "dialingCode": "977",
        "flag": "🇳🇵",
        "id": CountryId.Nepal,
        "name": "Nepal",
        "referenceExchangeRateAgainstUsd": 132.892713
    },
    {
        "countryCode": "NL",
        "currencyCode": "EUR",
        "dialingCode": "31",
        "flag": "🇳🇱",
        "id": CountryId.Netherlands,
        "name": "Netherlands",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "AN",
        "currencyCode": "ANG",
        "dialingCode": "599",
        "flag": "",
        "id": CountryId.NetherlandsAntilles,
        "name": "Netherlands Antilles",
        "referenceExchangeRateAgainstUsd": 1.79
    },
    {
        "countryCode": "NC",
        "currencyCode": "XPF",
        "dialingCode": "687",
        "flag": "🇳🇨",
        "id": CountryId.NewCaledonia,
        "name": "New Caledonia",
        "referenceExchangeRateAgainstUsd": 112.568436
    },
    {
        "countryCode": "NZ",
        "currencyCode": "NZD",
        "dialingCode": "64",
        "flag": "🇳🇿",
        "id": CountryId.NewZealand,
        "name": "New Zealand",
        "referenceExchangeRateAgainstUsd": 1.711312
    },
    {
        "countryCode": "NI",
        "currencyCode": "NIO",
        "dialingCode": "505",
        "flag": "🇳🇮",
        "id": CountryId.Nicaragua,
        "name": "Nicaragua",
        "referenceExchangeRateAgainstUsd": 36.608845
    },
    {
        "countryCode": "NE",
        "currencyCode": "XOF",
        "dialingCode": "227",
        "flag": "🇳🇪",
        "id": CountryId.Niger,
        "name": "Niger",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "NG",
        "currencyCode": "NGN",
        "dialingCode": "234",
        "flag": "🇳🇬",
        "id": CountryId.Nigeria,
        "name": "Nigeria",
        "referenceExchangeRateAgainstUsd": 824.615248
    },
    {
        "countryCode": "NU",
        "currencyCode": "NZD",
        "dialingCode": "683",
        "flag": "🇳🇺",
        "id": CountryId.Niue,
        "name": "Niue",
        "referenceExchangeRateAgainstUsd": 1.711312
    },
    {
        "countryCode": "NF",
        "currencyCode": "AUD",
        "dialingCode": "672",
        "flag": "🇳🇫",
        "id": CountryId.NorfolkIsland,
        "name": "Norfolk Island",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "MP",
        "currencyCode": "USD",
        "dialingCode": "1670",
        "flag": "🇲🇵",
        "id": CountryId.NorthernMarianaIslands,
        "name": "Northern Mariana Islands",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "NO",
        "currencyCode": "NOK",
        "dialingCode": "47",
        "flag": "🇳🇴",
        "id": CountryId.Norway,
        "name": "Norway",
        "referenceExchangeRateAgainstUsd": 11.156498
    },
    {
        "countryCode": "OM",
        "currencyCode": "OMR",
        "dialingCode": "968",
        "flag": "🇴🇲",
        "id": CountryId.Oman,
        "name": "Oman",
        "referenceExchangeRateAgainstUsd": 0.384497
    },
    {
        "countryCode": "PK",
        "currencyCode": "PKR",
        "dialingCode": "92",
        "flag": "🇵🇰",
        "id": CountryId.Pakistan,
        "name": "Pakistan",
        "referenceExchangeRateAgainstUsd": 279.45089
    },
    {
        "countryCode": "PW",
        "currencyCode": "USD",
        "dialingCode": "680",
        "flag": "🇵🇼",
        "id": CountryId.Palau,
        "name": "Palau",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "PA",
        "currencyCode": "PAB",
        "dialingCode": "507",
        "flag": "🇵🇦",
        "id": CountryId.Panama,
        "name": "Panama",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "PG",
        "currencyCode": "PGK",
        "dialingCode": "675",
        "flag": "🇵🇬",
        "id": CountryId.PapuaNewGuinea,
        "name": "Papua New Guinea",
        "referenceExchangeRateAgainstUsd": 3.738727
    },
    {
        "countryCode": "PY",
        "currencyCode": "PYG",
        "dialingCode": "595",
        "flag": "🇵🇾",
        "id": CountryId.Paraguay,
        "name": "Paraguay",
        "referenceExchangeRateAgainstUsd": 7466.582745
    },
    {
        "countryCode": "PE",
        "currencyCode": "PEN",
        "dialingCode": "51",
        "flag": "🇵🇪",
        "id": CountryId.Peru,
        "name": "Peru",
        "referenceExchangeRateAgainstUsd": 3.86512
    },
    {
        "countryCode": "PH",
        "currencyCode": "PHP",
        "dialingCode": "63",
        "flag": "🇵🇭",
        "id": CountryId.Philippines,
        "name": "Philippines",
        "referenceExchangeRateAgainstUsd": 56.76762
    },
    {
        "countryCode": "PN",
        "currencyCode": "NZD",
        "dialingCode": "64",
        "flag": "🇵🇳",
        "id": CountryId.Pitcairn,
        "name": "Pitcairn",
        "referenceExchangeRateAgainstUsd": 1.711312
    },
    {
        "countryCode": "PL",
        "currencyCode": "PLN",
        "dialingCode": "48",
        "flag": "🇵🇱",
        "id": CountryId.Poland,
        "name": "Poland",
        "referenceExchangeRateAgainstUsd": 4.20779
    },
    {
        "countryCode": "PT",
        "currencyCode": "EUR",
        "dialingCode": "351",
        "flag": "🇵🇹",
        "id": CountryId.Portugal,
        "name": "Portugal",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "PR",
        "currencyCode": "USD",
        "dialingCode": "1939",
        "flag": "🇵🇷",
        "id": CountryId.PuertoRico,
        "name": "Puerto Rico",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "QA",
        "currencyCode": "QAR",
        "dialingCode": "974",
        "flag": "🇶🇦",
        "id": CountryId.Qatar,
        "name": "Qatar",
        "referenceExchangeRateAgainstUsd": 3.64
    },
    {
        "countryCode": "RO",
        "currencyCode": "RON",
        "dialingCode": "40",
        "flag": "🇷🇴",
        "id": CountryId.Romania,
        "name": "Romania",
        "referenceExchangeRateAgainstUsd": 4.672765
    },
    {
        "countryCode": "RU",
        "currencyCode": "RUB",
        "dialingCode": "7",
        "flag": "🇷🇺",
        "id": CountryId.Russia,
        "name": "Russia",
        "referenceExchangeRateAgainstUsd": 93.603471
    },
    {
        "countryCode": "RW",
        "currencyCode": "RWF",
        "dialingCode": "250",
        "flag": "🇷🇼",
        "id": CountryId.Rwanda,
        "name": "Rwanda",
        "referenceExchangeRateAgainstUsd": 1255.519591
    },
    {
        "countryCode": "RE",
        "currencyCode": "EUR",
        "dialingCode": "262",
        "flag": "🇷🇪",
        "id": CountryId.Reunion,
        "name": "Reunion",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "BL",
        "currencyCode": "EUR",
        "dialingCode": "590",
        "flag": "🇧🇱",
        "id": CountryId.SaintBarthelemy,
        "name": "Saint Barthelemy",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "SH",
        "currencyCode": "SHP",
        "dialingCode": "290",
        "flag": "🇸🇭",
        "id": CountryId.SaintHelenaAscensionAndTristanDaCunha,
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "referenceExchangeRateAgainstUsd": 0.821186
    },
    {
        "countryCode": "KN",
        "currencyCode": "XCD",
        "dialingCode": "1869",
        "flag": "🇰🇳",
        "id": CountryId.SaintKittsAndNevis,
        "name": "Saint Kitts and Nevis",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "LC",
        "currencyCode": "XCD",
        "dialingCode": "1758",
        "flag": "🇱🇨",
        "id": CountryId.SaintLucia,
        "name": "Saint Lucia",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "MF",
        "currencyCode": "EUR",
        "dialingCode": "590",
        "flag": "🇲🇫",
        "id": CountryId.SaintMartin,
        "name": "Saint Martin",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "PM",
        "currencyCode": "EUR",
        "dialingCode": "508",
        "flag": "🇵🇲",
        "id": CountryId.SaintPierreAndMiquelon,
        "name": "Saint Pierre and Miquelon",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "VC",
        "currencyCode": "XCD",
        "dialingCode": "1784",
        "flag": "🇻🇨",
        "id": CountryId.SaintVincentAndTheGrenadines,
        "name": "Saint Vincent and the Grenadines",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "MM",
        "currencyCode": "MMR",
        "dialingCode": "95",
        "flag": "🇲🇲",
        "id": CountryId.Myanmar,
        "name": "Myanmar",
        "referenceExchangeRateAgainstUsd": 2101.14
    },
    {
        "countryCode": "SM",
        "currencyCode": "EUR",
        "dialingCode": "378",
        "flag": "🇸🇲",
        "id": CountryId.SanMarino,
        "name": "San Marino",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "ST",
        "currencyCode": "STN",
        "dialingCode": "239",
        "flag": "🇸🇹",
        "id": CountryId.SaoTomeAndPrincipe,
        "name": "Sao Tome and Principe",
        "referenceExchangeRateAgainstUsd": 23.111376
    },
    {
        "countryCode": "AF",
        "currencyCode": "AFN",
        "dialingCode": "93",
        "flag": "🇦🇫",
        "id": CountryId.Afghanistan,
        "name": "Afghanistan",
        "referenceExchangeRateAgainstUsd": 74.727055
    },
    {
        "countryCode": "AQ",
        "currencyCode": "XCD",
        "dialingCode": "672",
        "flag": "🇦🇶",
        "id": CountryId.Antarctica,
        "name": "Antarctica",
        "referenceExchangeRateAgainstUsd": 2.7
    },
    {
        "countryCode": "BA",
        "currencyCode": "BAM",
        "dialingCode": "387",
        "flag": "🇧🇦",
        "id": CountryId.BosniaAndHerzegovina,
        "name": "Bosnia and Herzegovina",
        "referenceExchangeRateAgainstUsd": 1.844976
    },
    {
        "countryCode": "CD",
        "currencyCode": "CDF",
        "dialingCode": "243",
        "flag": "🇨🇩",
        "id": CountryId.DominicanRepublicOfCongo,
        "name": "Dominican Remasters of Congo",
        "referenceExchangeRateAgainstUsd": 2514.67226
    },
    {
        "countryCode": "GH",
        "currencyCode": "GHS",
        "dialingCode": "233",
        "flag": "🇬🇭",
        "id": CountryId.Ghana,
        "name": "Ghana",
        "referenceExchangeRateAgainstUsd": 11.930723
    },
    {
        "countryCode": "VA",
        "currencyCode": "EUR",
        "dialingCode": "379",
        "flag": "🇻🇦",
        "id": CountryId.HolySee,
        "name": "Holy See (Vatican City State)",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "IQ",
        "currencyCode": "IQD",
        "dialingCode": "964",
        "flag": "🇮🇶",
        "id": CountryId.Iraq,
        "name": "Iraq",
        "referenceExchangeRateAgainstUsd": 1308.267007
    },
    {
        "countryCode": "LI",
        "currencyCode": "CHF",
        "dialingCode": "423",
        "flag": "🇱🇮",
        "id": CountryId.Liechtenstein,
        "name": "Liechtenstein",
        "referenceExchangeRateAgainstUsd": 0.893285
    },
    {
        "countryCode": "MZ",
        "currencyCode": "MZN",
        "dialingCode": "258",
        "flag": "🇲🇿",
        "id": CountryId.Mozambique,
        "name": "Mozambique",
        "referenceExchangeRateAgainstUsd": 63.87981
    },
    {
        "countryCode": "PS",
        "currencyCode": "ILS",
        "dialingCode": "970",
        "flag": "🇵🇸",
        "id": CountryId.PalestinianTerritoryOccupied,
        "name": "Palestinian Territory, Occupied",
        "referenceExchangeRateAgainstUsd": 4.057882
    },
    {
        "countryCode": "SA",
        "currencyCode": "SAR",
        "dialingCode": "966",
        "flag": "🇸🇦",
        "id": CountryId.SaudiArabia,
        "name": "Saudi Arabia",
        "referenceExchangeRateAgainstUsd": 3.75
    },
    {
        "countryCode": "SN",
        "currencyCode": "XOF",
        "dialingCode": "221",
        "flag": "🇸🇳",
        "id": CountryId.Senegal,
        "name": "Senegal",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "RS",
        "currencyCode": "RSD",
        "dialingCode": "381",
        "flag": "🇷🇸",
        "id": CountryId.Serbia,
        "name": "Serbia",
        "referenceExchangeRateAgainstUsd": 110.416424
    },
    {
        "countryCode": "SC",
        "currencyCode": "SCR",
        "dialingCode": "248",
        "flag": "🇸🇨",
        "id": CountryId.Seychelles,
        "name": "Seychelles",
        "referenceExchangeRateAgainstUsd": 13.191239
    },
    {
        "countryCode": "SL",
        "currencyCode": "SLL",
        "dialingCode": "232",
        "flag": "🇸🇱",
        "id": CountryId.SierraLeone,
        "name": "Sierra Leone",
        "referenceExchangeRateAgainstUsd": 22462.46724
    },
    {
        "countryCode": "SG",
        "currencyCode": "SGD",
        "dialingCode": "65",
        "flag": "🇸🇬",
        "id": CountryId.Singapore,
        "name": "Singapore",
        "referenceExchangeRateAgainstUsd": 1.36794
    },
    {
        "countryCode": "SK",
        "currencyCode": "EUR",
        "dialingCode": "421",
        "flag": "🇸🇰",
        "id": CountryId.Slovakia,
        "name": "Slovakia",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "SI",
        "currencyCode": "EUR",
        "dialingCode": "386",
        "flag": "🇸🇮",
        "id": CountryId.Slovenia,
        "name": "Slovenia",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "SB",
        "currencyCode": "SBD",
        "dialingCode": "677",
        "flag": "🇸🇧",
        "id": CountryId.SolomonIslands,
        "name": "Solomon Islands",
        "referenceExchangeRateAgainstUsd": 8.474735
    },
    {
        "countryCode": "SO",
        "currencyCode": "SOS",
        "dialingCode": "252",
        "flag": "🇸🇴",
        "id": CountryId.Somalia,
        "name": "Somalia",
        "referenceExchangeRateAgainstUsd": 571.746501
    },
    {
        "countryCode": "ZA",
        "currencyCode": "ZAR",
        "dialingCode": "27",
        "flag": "🇿🇦",
        "id": CountryId.SouthAfrica,
        "name": "South Africa",
        "referenceExchangeRateAgainstUsd": 19.039045
    },
    {
        "countryCode": "SS",
        "currencyCode": "SSP",
        "dialingCode": "211",
        "flag": "🇸🇸",
        "id": CountryId.SouthSudan,
        "name": "South Sudan",
        "referenceExchangeRateAgainstUsd": 1030.251036
    },
    {
        "countryCode": "GS",
        "currencyCode": "GBP",
        "dialingCode": "500",
        "flag": "🇬🇸",
        "id": CountryId.SouthGeorgiaAndTheSouthSandwichIslands,
        "name": "South Georgia and the South Sandwich Islands",
        "referenceExchangeRateAgainstUsd": 0.821191
    },
    {
        "countryCode": "ES",
        "currencyCode": "EUR",
        "dialingCode": "34",
        "flag": "🇪🇸",
        "id": CountryId.Spain,
        "name": "Spain",
        "referenceExchangeRateAgainstUsd": 0.942866
    },
    {
        "countryCode": "LK",
        "currencyCode": "LKR",
        "dialingCode": "94",
        "flag": "🇱🇰",
        "id": CountryId.SriLanka,
        "name": "Sri Lanka",
        "referenceExchangeRateAgainstUsd": 326.912398
    },
    {
        "countryCode": "SD",
        "currencyCode": "SDG",
        "dialingCode": "249",
        "flag": "🇸🇩",
        "id": CountryId.Sudan,
        "name": "Sudan",
        "referenceExchangeRateAgainstUsd": 576.966739
    },
    {
        "countryCode": "SR",
        "currencyCode": "SRD",
        "dialingCode": "597",
        "flag": "🇸🇷",
        "id": CountryId.Suriname,
        "name": "Suriname",
        "referenceExchangeRateAgainstUsd": 38.192133
    },
    {
        "countryCode": "SJ",
        "currencyCode": "NOK",
        "dialingCode": "47",
        "flag": "🇸🇯",
        "id": CountryId.SvalbardAndJanMayen,
        "name": "Svalbard and Jan Mayen",
        "referenceExchangeRateAgainstUsd": 11.156498
    },
    {
        "countryCode": "SZ",
        "currencyCode": "SZL",
        "dialingCode": "268",
        "flag": "🇸🇿",
        "id": CountryId.Eswatini,
        "name": "Eswatini",
        "referenceExchangeRateAgainstUsd": 19.039012
    },
    {
        "countryCode": "SE",
        "currencyCode": "SEK",
        "dialingCode": "46",
        "flag": "🇸🇪",
        "id": CountryId.Sweden,
        "name": "Sweden",
        "referenceExchangeRateAgainstUsd": 11.110876
    },
    {
        "countryCode": "CH",
        "currencyCode": "CHF",
        "dialingCode": "41",
        "flag": "🇨🇭",
        "id": CountryId.Switzerland,
        "name": "Switzerland",
        "referenceExchangeRateAgainstUsd": 0.893285
    },
    {
        "countryCode": "SY",
        "currencyCode": "SYP",
        "dialingCode": "963",
        "flag": "🇸🇾",
        "id": CountryId.Syria,
        "name": "Syria",
        "referenceExchangeRateAgainstUsd": 12931.31155
    },
    {
        "countryCode": "TW",
        "currencyCode": "NTD",
        "dialingCode": "886",
        "flag": "🇹🇼",
        "id": CountryId.Taiwan,
        "name": "Taiwan",
        "referenceExchangeRateAgainstUsd": 32.85
    },
    {
        "countryCode": "TJ",
        "currencyCode": "TJS",
        "dialingCode": "992",
        "flag": "🇹🇯",
        "id": CountryId.Tajikistan,
        "name": "Tajikistan",
        "referenceExchangeRateAgainstUsd": 10.933311
    },
    {
        "countryCode": "TZ",
        "currencyCode": "TZS",
        "dialingCode": "255",
        "flag": "🇹🇿",
        "id": CountryId.Tanzania,
        "name": "Tanzania",
        "referenceExchangeRateAgainstUsd": 2513.358652
    },
    {
        "countryCode": "TH",
        "currencyCode": "THB",
        "dialingCode": "66",
        "flag": "🇹🇭",
        "id": CountryId.Thailand,
        "name": "Thailand",
        "referenceExchangeRateAgainstUsd": 36.169516
    },
    {
        "countryCode": "TL",
        "currencyCode": "USD",
        "dialingCode": "670",
        "flag": "🇹🇱",
        "id": CountryId.TimorLeste,
        "name": "Timor-Leste",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "TG",
        "currencyCode": "XOF",
        "dialingCode": "228",
        "flag": "🇹🇬",
        "id": CountryId.Togo,
        "name": "Togo",
        "referenceExchangeRateAgainstUsd": 618.778311
    },
    {
        "countryCode": "TK",
        "currencyCode": "NZD",
        "dialingCode": "690",
        "flag": "🇹🇰",
        "id": CountryId.Tokelau,
        "name": "Tokelau",
        "referenceExchangeRateAgainstUsd": 1.711312
    },
    {
        "countryCode": "TO",
        "currencyCode": "TOP",
        "dialingCode": "676",
        "flag": "🇹🇴",
        "id": CountryId.Tonga,
        "name": "Tonga",
        "referenceExchangeRateAgainstUsd": 2.353887
    },
    {
        "countryCode": "TT",
        "currencyCode": "TTD",
        "dialingCode": "1868",
        "flag": "🇹🇹",
        "id": CountryId.TrinidadAndTobago,
        "name": "Trinidad and Tobago",
        "referenceExchangeRateAgainstUsd": 6.771168
    },
    {
        "countryCode": "TN",
        "currencyCode": "TND",
        "dialingCode": "216",
        "flag": "🇹🇳",
        "id": CountryId.Tunisia,
        "name": "Tunisia",
        "referenceExchangeRateAgainstUsd": 3.164299
    },
    {
        "countryCode": "TR",
        "currencyCode": "TRY",
        "dialingCode": "90",
        "flag": "🇹🇷",
        "id": CountryId.Turkey,
        "name": "Turkey",
        "referenceExchangeRateAgainstUsd": 28.121146
    },
    {
        "countryCode": "TM",
        "currencyCode": "TMT",
        "dialingCode": "993",
        "flag": "🇹🇲",
        "id": CountryId.Turkmenistan,
        "name": "Turkmenistan",
        "referenceExchangeRateAgainstUsd": 3.499934
    },
    {
        "countryCode": "TC",
        "currencyCode": "USD",
        "dialingCode": "1649",
        "flag": "🇹🇨",
        "id": CountryId.TurksAndCaicosIslands,
        "name": "Turks and Caicos Islands",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "TV",
        "currencyCode": "AUD",
        "dialingCode": "688",
        "flag": "🇹🇻",
        "id": CountryId.Tuvalu,
        "name": "Tuvalu",
        "referenceExchangeRateAgainstUsd": 1.572893
    },
    {
        "countryCode": "UG",
        "currencyCode": "UGX",
        "dialingCode": "256",
        "flag": "🇺🇬",
        "id": CountryId.Uganda,
        "name": "Uganda",
        "referenceExchangeRateAgainstUsd": 3765.813997
    },
    {
        "countryCode": "UA",
        "currencyCode": "UAH",
        "dialingCode": "380",
        "flag": "🇺🇦",
        "id": CountryId.Ukraine,
        "name": "Ukraine",
        "referenceExchangeRateAgainstUsd": 36.587473
    },
    {
        "countryCode": "AE",
        "currencyCode": "AED",
        "dialingCode": "971",
        "flag": "🇦🇪",
        "id": CountryId.UnitedArabEmirates,
        "name": "United Arab Emirates",
        "referenceExchangeRateAgainstUsd": 3.6725
    },
    {
        "countryCode": "GB",
        "currencyCode": "GBP",
        "dialingCode": "44",
        "flag": "🇬🇧",
        "id": CountryId.UnitedKingdom,
        "name": "United Kingdom",
        "referenceExchangeRateAgainstUsd": 0.821191
    },
    {
        "countryCode": "US",
        "currencyCode": "USD",
        "dialingCode": "1",
        "flag": "🇺🇸",
        "id": CountryId.UnitedStates,
        "name": "United States",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "UY",
        "currencyCode": "UYU",
        "dialingCode": "598",
        "flag": "🇺🇾",
        "id": CountryId.Uruguay,
        "name": "Uruguay",
        "referenceExchangeRateAgainstUsd": 39.752598
    },
    {
        "countryCode": "UZ",
        "currencyCode": "UZS",
        "dialingCode": "998",
        "flag": "🇺🇿",
        "id": CountryId.Uzbekistan,
        "name": "Uzbekistan",
        "referenceExchangeRateAgainstUsd": 12204.15741
    },
    {
        "countryCode": "VU",
        "currencyCode": "VUV",
        "dialingCode": "678",
        "flag": "🇻🇺",
        "id": CountryId.Vanuatu,
        "name": "Vanuatu",
        "referenceExchangeRateAgainstUsd": 121.264151
    },
    {
        "countryCode": "VE",
        "currencyCode": "USD",
        "dialingCode": "58",
        "flag": "🇻🇪",
        "id": CountryId.Venezuela,
        "name": "Venezuela",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "VN",
        "currencyCode": "VND",
        "dialingCode": "84",
        "flag": "🇻🇳",
        "id": CountryId.Vietnam,
        "name": "Vietnam",
        "referenceExchangeRateAgainstUsd": 24581.03744
    },
    {
        "countryCode": "VG",
        "currencyCode": "USD",
        "dialingCode": "1284",
        "flag": "🇻🇬",
        "id": CountryId.VirginIslandsBritish,
        "name": "Virgin Islands, British",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "VI",
        "currencyCode": "USD",
        "dialingCode": "1340",
        "flag": "🇻🇮",
        "id": CountryId.VirginIslandsUnitedStates,
        "name": "Virgin Islands, U.S.",
        "referenceExchangeRateAgainstUsd": 1
    },
    {
        "countryCode": "WF",
        "currencyCode": "XPF",
        "dialingCode": "681",
        "flag": "🇼🇫",
        "id": CountryId.WallisAndFutuna,
        "name": "Wallis and Futuna",
        "referenceExchangeRateAgainstUsd": 112.568436
    },
    {
        "countryCode": "YE",
        "currencyCode": "YER",
        "dialingCode": "967",
        "flag": "🇾🇪",
        "id": CountryId.Yemen,
        "name": "Yemen",
        "referenceExchangeRateAgainstUsd": 250.282115
    },
    {
        "countryCode": "ZM",
        "currencyCode": "ZMW",
        "dialingCode": "260",
        "flag": "🇿🇲",
        "id": CountryId.Zambia,
        "name": "Zambia",
        "referenceExchangeRateAgainstUsd": 21.711263
    },
    {
        "countryCode": "ZW",
        "currencyCode": "ZWD",
        "dialingCode": "263",
        "flag": "🇿🇼",
        "id": CountryId.Zimbabwe,
        "name": "Zimbabwe",
        "referenceExchangeRateAgainstUsd": 361.9
    },
    {
        "countryCode": "MG",
        "currencyCode": "MGF",
        "dialingCode": "261",
        "flag": "🇲🇬",
        "id": CountryId.Madagascar,
        "name": "Madagascar",
        "referenceExchangeRateAgainstUsd": 22650
    }
] satisfies Array<Country>;

export const countryZodValidator = zod.object({
    countryCode: zod.string(),
    currencyCode: zod.string(),
    dialingCode: zod.string(),
    flag: zod.string(),
    id: zod.enum(CountryId),
    name: zod.string(),
    referenceExchangeRateAgainstUsd: zod.number(),
});

export const legacyCountryValidator: zod.ZodType<Array<Country>> = zod.array(countryZodValidator);
